export { default } from "./AnimatedImage";